<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2021-01-24 17:14 -->
<template>
  <div>
    <app-loading v-show="loading">Buscando direcciones</app-loading>
    <div class="row">
      <div class="col-sm-6 mb-2" v-for="(l, i) in addresses" :key="i">
        <button
          style="min-height: 60px"
          class=" btn btn-outline-primary shadow-sm btn-block"
          :class="{ active: idLastClicked == l.id }"
          @click="clickAddressHandler(l)"
        >
          <small>{{ l.address }}</small>
          <small class="d-block">{{ l.delivery_price | money }}</small>
        </button>
      </div>
    </div>
    <div class="form-group">
      <label for="">Dirección *</label>
      <input
        ref="elInputAddress"
        type="text"
        class="form-control"
        v-model="internalValue"
      />
    </div>
  </div>
</template>
<script>
import { StoreService } from "src/lt-module/store-module/service.js";
export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    value: {
      //
    }
  },

  data: () => ({
    loading: false,
    addresses: [],
    seeAddAddress: false,
    idLastClicked: null
  }),

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    clickAddressHandler(value) {
      this.idLastClicked = value.id;
      this.seeAddAddress = false;
      this.$emit("input", value.address);
      if (value.delivery_price != null && value.delivery_price > 0) {
        this.$emit("set-delivery-price", value.delivery_price);
      }
    },
    async searchByPhone(phone) {
      this.reset();
      this.loading = true;
      this.addresses = await StoreService.getClientAddresses({
        phone
      });
      this.loading = false;
      this.idLastClicked = null;
    },
    reset() {
      this.loading = false;
      this.addresses = [];
      this.seeAddAddress = false;
      this.idLastClicked = null;
    }
  }
};
</script>

<style scoped></style>
